import script from "./ListarConvenios.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarConvenios.vue?vue&type=script&setup=true&lang=js"

import "./ListarConvenios.vue?vue&type=style&index=0&id=c5446764&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5446764"]])

export default __exports__